import React from "react";
import CircleButton from "../global/circle-button";
import SocialLinks from "./social-links";
import EvoLogo from "../../assets/evo-logo.svg";
import LupLogo from "../../assets/lup-logo.svg";
import BPLogo from "../../assets/bp-logo.svg";
import AtsLogo from "../../assets/ats-logo.svg";
import EvoHotelLogo from "../../assets/evo-hotel-logo-2-white.svg";
import L9Logo from "../../assets/l9-logo.svg";

const Footer = () => {
  const handleCircleButtonClick = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
  }

  return (
    <footer className="footer">
      <div className="footer__title-wrapper">
        <div className="footer__title-flex-wrapper">
          <h2 className="footer__title">We invite all humans</h2>
          <div className="footer__desktop-button-wrapper">
            <CircleButton
              title="Back to top"
              direction="up"
              desktopTextSide="left"
              onClick={handleCircleButtonClick}
            />
          </div>
        </div>
        <p className="footer__sub-title">An evo x Lake Union Partners project</p>
      </div>
      <div className="footer__data-wrapper">
        <div className="footer__copy-links-wrapper">
          <div className="footer__logos-wrapper">
            <div className="footer__logos-wrapper--row">
              <a className="footer__logo-link" href="https://evo.com/" target="_blank">
                <EvoLogo className="footer__logo footer__logo--evo" />
              </a>
              <a className="footer__logo-link" href="https://saltlakeboulderingproject.com/" target="_blank">
                <BPLogo className="footer__logo" />
              </a>
              <a className="footer__logo-link" href="https://www.alltogetherskatepark.com/" target="_blank">
                <AtsLogo className="footer__logo footer__logo--ats" />
              </a>
            </div>
            <div className="footer__logos-wrapper--row">
              <a className="footer__logo-link" href="https://www.levelninesports.com/retail/salt-lake-city-utah-ski-shop" target="_blank">
                <L9Logo className="footer__logo footer__logo--l9" />
              </a>
              <span className="footer__logo-link"><EvoHotelLogo className="footer__logo footer__logo--evo-hotel" /></span>
              <a className="footer__logo-link" href="https://lakeunionpartners.com/" target="_blank">
                <LupLogo className="footer__logo" />
              </a>
            </div>
            <div className="footer__logos-wrapper--row footer__desktop-copy-wrapper">
              <span>&copy; { new Date().getFullYear() } evo | <a className="footer__copy-link" href="https://www.evo.com/what-is-your-privacy-policy" target="_blank">Privacy Policy</a></span>
            </div>
          </div>
        </div>
        <div className="footer__mobile-button-wrapper">
          <CircleButton title="Back to top" direction="up" onClick={handleCircleButtonClick} />
        </div>
        <div className="footer__social-links-wrapper">
          <SocialLinks />
        </div>
        <div className="footer__mobile-copy-wrapper">
          <span>&copy; 2001-{ new Date().getFullYear() } evo | <a className="footer__copy-link" href="https://www.evo.com/what-is-your-privacy-policy" target="_blank">Privacy Policy</a></span>
        </div>
      </div>
    </footer>
  )
}

export default Footer
